var LogoutService = function($resource, $window) {

    var logOutServicesApi = '/participant-web-services/rest/nonauth/logOut';

    var logOutPartAuthApi = '/participant-authentication/rest/nonauth/logOut';

  
    var legacySiteBaseURL = $window.iframeUrl;
    if (iframeUrl === ""){
       var relativeBaseURL = $window.location.href.substring(0, $window.location.href.indexOf("/#/"));
       legacySiteBaseURL = relativeBaseURL;

       if ( legacySiteBaseURL.indexOf("/ui/") > 0 ){
           legacySiteBaseURL = legacySiteBaseURL.substring(0, legacySiteBaseURL.indexOf("/ui/"));
       }
    }
    var logOutLegacyApi = '/wrLogoutRedirect.do';

    return {

        logOutServices : $resource(__baseApiUrl__ + logOutServicesApi, {}, {
          query : {
            method : 'GET',
            isArray : false
          }
        }),
        
        logOutPartAuth : $resource(__baseApiUrl__ + logOutPartAuthApi, {}, {
            query : {
              method : 'GET',
              isArray : false
            }
          }),


        logOutLegacy : $resource(legacySiteBaseURL + logOutLegacyApi, {} , {
          query : {
            method : 'GET',
            isArray : false
          }
        })

     };// End of return
};

LogoutService.$inject = [ '$resource', '$window' ];
export default LogoutService;
